import { withRouter } from "react-router";
import React from "react";

import { ArrayUtil, DateUtil } from "../../../util";
import ComparePanel, { TargetValueType } from "../CompareValuePanel";
import I18n from "../../../i18n";
import Layout from "../../../components/layout/Layout";
import IndividualUserComp from "../../../components/report/individual_user/IndividualUserComp";
import ReportAction from "../../../actions/ReportAction";
import ROUTE from "../../../constants/route";

const { fetchPeople } = ReportAction;

class IndividualUser extends React.Component {
    comparePanel = null;
    dateRanges = {
    	[TargetValueType.Primary]: [],
    	[TargetValueType.Secondary]: []
    }
    constructor(props) {
    	super(props);
    	this.dateRanges = {
    		[TargetValueType.Primary]: DateUtil.getAllTimeDateRange(),
    		[TargetValueType.Secondary]: []
    	};
    	this.state = {
    		primaryData: null,
    		secondaryData: null,
    		id: null
    	};
    }
    componentDidMount() {
    	const defaultDate = DateUtil.getAllTimeDateRange();
    	const { location: { pathname }, history } = this.props;
    	const id = pathname.split("/")[2];
    	if (id && !isNaN(parseInt(id))) {
    		fetchPeople(id, {
    			start: defaultDate[0].format("X"),
    			end: defaultDate[1].format("X")
    		}).then(res => {
    			if (res)
    				this.setState({ primaryData: res || null, id });
    			else history.push(`/${ROUTE.PEOPLE_OVERVIEW}`);
    		});
    	} else {
    		history.push(`/${ROUTE.PEOPLE_OVERVIEW}`);
    	}
    }
    onPrimaryDateChanged = (date) => {
    	const { id } = this.state;
    	if (date.length > 0) {
    		fetchPeople(id, {
    			start: date[0].format("X"),
    			end: date[1].format("X")
    		}).then(res => this.setState({ primaryData: res || null }));
    	} else {
    		fetchPeople(id).then(res => {
    			this.setState({ primaryData: res || null });
    		});
    	}
    	this.dateRanges[TargetValueType.Primary] = date;
    	this.forceUpdate();
    }
    onSecondaryDateChanged = (date) => {
    	console.log("onSecondaryDateChanged: ", date);
    	this.dateRanges[TargetValueType.Secondary] = date;
    	const { id } = this.state;
    	if (date.length > 0) {
    		fetchPeople(id, {
    			start: date[0].format("X"),
    			end: date[1].format("X")
    		}).then(res => this.setState({ secondaryData: res || null }));
    	} else {
    		fetchPeople(id).then(res => {
    			this.setState({ secondaryData: res || null });
    		});
    	}
    	this.comparePanel.setShowCompare(ArrayUtil.isAliveArray(date));
    	this.forceUpdate();
    }

    render() {
    	const { primaryData, secondaryData } = this.state;
    	const showCompare = ArrayUtil.isAliveArray(this.dateRanges[TargetValueType.Secondary]);
    	return (
    		<Layout>
    			<div style={{ marginTop: 10 }} />
    			<ComparePanel
    				setRef={(ref) => { this.comparePanel = ref; }}
    				header={I18n.t("people")}
    				subHeader={I18n.t("people_individual_user")}
    				showSecondaryDatePicker
    				primaryDate={this.dateRanges[TargetValueType.Primary]}
    				secondaryDate={this.dateRanges[TargetValueType.Secondary]}
    				onPrimaryDateChanged={this.onPrimaryDateChanged}
    				onSecondaryDateChanged={this.onSecondaryDateChanged}
    				primaryComponent={<IndividualUserComp
    					data={primaryData} isVertical={showCompare} id="primary" />} //<UsageOverview data={primaryData} isVertical={showCompare} id="primary" />
    				secondaryComponent={<IndividualUserComp
    					data={secondaryData} isVertical={showCompare} id="secondary" />} //<UsageOverview data={secondaryData} isVertical={showCompare} id="secondary" />
    			>
    			</ComparePanel>
    		</Layout>);
    }
}

export default withRouter(IndividualUser);



/*
import { Row, Col } from 'antd';
import { withRouter } from 'react-router'
import React, { Component } from 'react';
import styled from 'styled-components'

import IndividualUserTimeline from '../../../components/report/individual_user/IndividualUserTimeline'
import Layout from '../../../components/layout/Layout'
import RecentVisitFeedback from '../../../components/report/individual_user/RecentVisitFeedback'
import StressIndividualUser from '../../../components/report/individual_user/StressIndividualUser'
import TableUserSessions from '../../../components/report/individual_user/TableUserSessions'
import TotalInformation from '../../../components/report/individual_user/TotalInformation'
import UserInformation from '../../../components/report/individual_user/UserInformation'
import ROUTE from '../../../constants/route'
import ReportAction from '../../../actions/ReportAction'
const { fetchPeople } = ReportAction

class IndividualUser extends Component {
    state = {}

    componentDidMount = () => {
        const { location: { pathname }, history } = this.props
        const id = pathname.split('/')[2]
        if (id && !isNaN(parseInt(id))) {
            fetchPeople(id)
        } else {
            history.push(`/${ROUTE.PEOPLE_OVERVIEW}`)
        }
    }

    render() {
        return (
            <Layout>
                <div style={{ fontSize: 24, margin: '10px 0' }}>People</div>
                <div style={{ fontSize: 18, margin: '10px 0' }}>Individual user</div>
                <Row gutter={16}>
                    <Col xl={24} xxl={12}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <UserInformation />
                            </Col>
                            <Col span={12}>
                                <TotalInformation total={1} description='Total test session' />
                                <TotalInformation total={1} description='Total test counseling' />
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <StressIndividualUser
                                    title="Stress level from provider"
                                    provider={true}
                                    chartId="provider" />
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <StressIndividualUser
                                    title="Stress test results"
                                    provider={false}
                                    chartId="user" />
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={24} xxl={12}>
                        <Row>
                            <Col span={24}>
                                <TableUserSessions />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <RecentVisitFeedback />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <IndividualUserTimeline />
                            </Col>
                        </Row>
                    </Col>
                </Row>


            </Layout>
        );
    }
}

export default withRouter(IndividualUser);
*/



// WEBPACK FOOTER //
// ./src/containers/ReportPanels/People/IndividualUser.js